module.exports = __webpack_public_path__ + "assets/img/00101.6e3b0954.png";